export enum BancoCodigo {
  BB = "001",
  SANTANDER = "033",
  CAIXA = "104",
  BRADESCO = "237",
  ITAU = "341",
  HSBC = "399",
  SICREDI = "748",
  BANRISUL = "041",
  BANCOOB = "756756",
}
